// Image Configuration - Update any image path here
export const imageConfig = {
  // Company Logos and Branding
  logo: {
    main: '/images/logo/mirani-marketing-logo.png',
    white: '/images/logo/mirani-marketing-logo-white.png',
    icon: '/images/logo/mirani-marketing-icon.png',
    favicon: '/favicon.ico'
  },

  // Header and Navigation
  header: {
    background: '/images/header/header-bg.jpg',
    topBarIcon: '/images/icons/rocket.svg'
  },

  // Hero Section
  hero: {
    mainBackground: '/images/hero/hero-bg.jpg',
    overlayPattern: '/images/hero/hero-pattern.svg',
    dashboardPreview: '/images/hero/dashboard-preview.png',
    analyticsChart: '/images/hero/analytics-chart.png',
    growthGraph: '/images/hero/growth-graph.png',
    heroIllustration: '/images/hero/digital-marketing-hero.png'
  },

  // Services Section
  services: {
    seoIcon: '/images/services/seo-icon.svg',
    ppcIcon: '/images/services/ppc-icon.svg',
    socialMediaIcon: '/images/services/social-media-icon.svg',
    webDesignIcon: '/images/services/web-design-icon.svg',
    contentMarketingIcon: '/images/services/content-marketing-icon.svg',
    analyticsIcon: '/images/services/analytics-icon.svg',
    aiIcon: '/images/services/ai-icon.svg',
    automationIcon: '/images/services/automation-icon.svg',
    
    // Service backgrounds
    seoBackground: '/images/services/seo-bg.jpg',
    ppcBackground: '/images/services/ppc-bg.jpg',
    socialBackground: '/images/services/social-bg.jpg'
  },

  // Portfolio Section
  portfolio: {
    project1: '/images/portfolio/project-1.jpg',
    project2: '/images/portfolio/project-2.jpg',
    project3: '/images/portfolio/project-3.jpg',
    project4: '/images/portfolio/project-4.jpg',
    project5: '/images/portfolio/project-5.jpg',
    project6: '/images/portfolio/project-6.jpg',
    
    // Before/After comparison images
    beforeAfter1Before: '/images/portfolio/before-after-1-before.jpg',
    beforeAfter1After: '/images/portfolio/before-after-1-after.jpg',
    beforeAfter2Before: '/images/portfolio/before-after-2-before.jpg',
    beforeAfter2After: '/images/portfolio/before-after-2-after.jpg'
  },

  // Team Section
  team: {
    ceo: '/images/team/ceo.jpg',
    cto: '/images/team/cto.jpg',
    marketingDirector: '/images/team/marketing-director.jpg',
    leadDeveloper: '/images/team/lead-developer.jpg',
    seoSpecialist: '/images/team/seo-specialist.jpg',
    designLead: '/images/team/design-lead.jpg',
    
    // Team group photos
    teamPhoto1: '/images/team/team-photo-1.jpg',
    teamPhoto2: '/images/team/team-photo-2.jpg',
    officePhoto1: '/images/team/office-photo-1.jpg',
    officePhoto2: '/images/team/office-photo-2.jpg'
  },

  // Testimonials Section
  testimonials: {
    client1: '/images/testimonials/client-1.jpg',
    client2: '/images/testimonials/client-2.jpg',
    client3: '/images/testimonials/client-3.jpg',
    client4: '/images/testimonials/client-4.jpg',
    client5: '/images/testimonials/client-5.jpg',
    client6: '/images/testimonials/client-6.jpg',
    
    // Company logos
    companyLogo1: '/images/testimonials/company-logo-1.png',
    companyLogo2: '/images/testimonials/company-logo-2.png',
    companyLogo3: '/images/testimonials/company-logo-3.png'
  },

  // About Section
  about: {
    aboutHero: '/images/about/about-hero.jpg',
    missionImage: '/images/about/mission.jpg',
    visionImage: '/images/about/vision.jpg',
    valuesImage: '/images/about/values.jpg',
    companyHistory: '/images/about/company-history.jpg',
    awards: '/images/about/awards.jpg'
  },

  // Careers Section
  careers: {
    careersHero: '/images/careers/careers-hero.jpg',
    officeLife1: '/images/careers/office-life-1.jpg',
    officeLife2: '/images/careers/office-life-2.jpg',
    officeLife3: '/images/careers/office-life-3.jpg',
    benefits1: '/images/careers/benefits-1.jpg',
    benefits2: '/images/careers/benefits-2.jpg',
    teamBuilding: '/images/careers/team-building.jpg',
    workEnvironment: '/images/careers/work-environment.jpg'
  },

  // Case Studies
  caseStudies: {
    study1Before: '/images/case-studies/study-1-before.jpg',
    study1After: '/images/case-studies/study-1-after.jpg',
    study1Graph: '/images/case-studies/study-1-graph.png',
    
    study2Before: '/images/case-studies/study-2-before.jpg',
    study2After: '/images/case-studies/study-2-after.jpg',
    study2Graph: '/images/case-studies/study-2-graph.png',
    
    study3Before: '/images/case-studies/study-3-before.jpg',
    study3After: '/images/case-studies/study-3-after.jpg',
    study3Graph: '/images/case-studies/study-3-graph.png'
  },

  // Blog Section
  blog: {
    featured1: '/images/blog/featured-1.jpg',
    featured2: '/images/blog/featured-2.jpg',
    featured3: '/images/blog/featured-3.jpg',
    authorAvatar1: '/images/blog/author-1.jpg',
    authorAvatar2: '/images/blog/author-2.jpg',
    authorAvatar3: '/images/blog/author-3.jpg'
  },

  // Contact Section
  contact: {
    contactHero: '/images/contact/contact-hero.jpg',
    officeExterior: '/images/contact/office-exterior.jpg',
    officeInterior: '/images/contact/office-interior.jpg',
    meetingRoom: '/images/contact/meeting-room.jpg'
  },

  // Icons and Graphics
  icons: {
    // Achievement icons
    trophy: '/images/icons/trophy.svg',
    star: '/images/icons/star.svg',
    award: '/images/icons/award.svg',
    growth: '/images/icons/growth.svg',
    target: '/images/icons/target.svg',
    
    // Service icons
    search: '/images/icons/search.svg',
    chart: '/images/icons/chart.svg',
    mobile: '/images/icons/mobile.svg',
    desktop: '/images/icons/desktop.svg',
    social: '/images/icons/social.svg',
    email: '/images/icons/email.svg',
    
    // Tech stack icons
    react: '/images/icons/tech/react.svg',
    nodejs: '/images/icons/tech/nodejs.svg',
    mongodb: '/images/icons/tech/mongodb.svg',
    typescript: '/images/icons/tech/typescript.svg'
  },

  // Background patterns and textures
  backgrounds: {
    pattern1: '/images/patterns/pattern-1.svg',
    pattern2: '/images/patterns/pattern-2.svg',
    gradient1: '/images/patterns/gradient-1.jpg',
    texture1: '/images/patterns/texture-1.jpg',
    geometric: '/images/patterns/geometric.svg'
  },

  // Platform and Tools Screenshots
  platforms: {
    revenueCloudFX: '/images/platforms/revenue-cloud-fx.png',
    crmDashboard: '/images/platforms/crm-dashboard.png',
    analyticsPanel: '/images/platforms/analytics-panel.png',
    leadManagement: '/images/platforms/lead-management.png',
    socialMediaDashboard: '/images/platforms/social-media-dashboard.png',
    seoTools: '/images/platforms/seo-tools.png'
  },

  // Locations
  locations: {
    office1Exterior: '/images/locations/office-1-exterior.jpg',
    office1Interior: '/images/locations/office-1-interior.jpg',
    office2Exterior: '/images/locations/office-2-exterior.jpg',
    office2Interior: '/images/locations/office-2-interior.jpg',
    mapLocation1: '/images/locations/map-location-1.png',
    mapLocation2: '/images/locations/map-location-2.png'
  },

  // Social Media and Brand Assets
  social: {
    facebookCover: '/images/social/facebook-cover.jpg',
    twitterCover: '/images/social/twitter-cover.jpg',
    linkedinCover: '/images/social/linkedin-cover.jpg',
    instagramProfile: '/images/social/instagram-profile.jpg'
  },

  // Placeholder images for development
  placeholders: {
    default: '/images/placeholders/default.jpg',
    avatar: '/images/placeholders/avatar.jpg',
    landscape: '/images/placeholders/landscape.jpg',
    portrait: '/images/placeholders/portrait.jpg',
    logo: '/images/placeholders/logo.png'
  }
};

// Helper function to get image with fallback
export const getImage = (path: string, fallback: string = imageConfig.placeholders.default): string => {
  return path || fallback;
};

// Helper function to get responsive image sources
export const getResponsiveImage = (basePath: string) => ({
  mobile: `${basePath}-mobile.jpg`,
  tablet: `${basePath}-tablet.jpg`, 
  desktop: `${basePath}-desktop.jpg`,
  retina: `${basePath}-retina.jpg`
});